export enum RADIO_ALIGN {
  DEFAULT = 'default',
  VERTICAL = 'vertical'
}
